module.exports = __webpack_public_path__ + "img/0x5853ccBDc428d5fC9F8C1d3599B252C88477b460.317fa043.png";